<script>
export default {
  name: "DidoApidocUsageGeofields",
};
</script>

<template>
  <div class="q-mt-md line-height-15">
    Certains millésimes peuvent contenir des colonnes faisant référence a une
    géographie.
    <br /><br />
    Il est possible d'exporter ce millésime au format geojson en précisant le
    champ de projection dans le paramètre
    <span class="bg-black text-white q-pa-xs">geoField</span>
    <br /><br />
    Le paramètre
    <span class="bg-black text-white q-pa-xs">geoField</span> doit être
    construit de la manière suivante :
    <span class="bg-black text-white q-pa-xs">geoField=champDeProjection</span>.
    <br /><br />
    Un exemple :
    <span class="bg-black text-white q-pa-xs"
      >$BASE_URL_API/datafiles/{datafileRid}/spatial/geojson?millesime={millesimeValue}&geoField={champDeProjection}</span
    >
    <br /><br />
    La liste des champs de projection disponibles pour un millésime est
    disponible dans le champ
    <span class="underline-dotted">geoFields</span> de l'objet renvoyé par la
    requête suivante :
    <br />
    <span class="bg-black text-white q-pa-xs"
      >$BASE_URL_API/datafiles/{datafileRid}?millesime={millesimeValue}</span
    >. <br /><br />
    Certains référentiels et nomenclatures peuvent également contenir une
    géographie et peuvent donc être exportés au format geojson.
    <br />
    Exemple avec l'export du cog projeté selon le champ
    <span class="underline-dotted">SHAPE</span> :
    <span class="bg-black text-white q-pa-xs"
      >$BASE_URL_API/referentiels/cog/spatial/geojson?geoField=SHAPE</span
    >
  </div>
</template>
